import { render, staticRenderFns } from "./SubmissionsReview.vue?vue&type=template&id=7a1e0208&scoped=true&"
import script from "./SubmissionsReview.vue?vue&type=script&lang=js&"
export * from "./SubmissionsReview.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionsReview.vue?vue&type=style&index=0&id=7a1e0208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1e0208",
  null
  
)

export default component.exports